import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { RestApiService } from "../shared/rest-api.service";
import { Config } from "../shared/config";

@Component({
    selector: "app-confirm",
    templateUrl: "./confirm.component.html",
    styleUrls: ["./confirm.component.scss"],
})
export class ConfirmComponent implements OnInit {
    kaid: string; //KartenID
    confKey: string; //Confirm Key
    art: string; //Art der Kondolenz
    resultConfirm:any;
    erg: string[];
    status_message: string;

    constructor(private route: ActivatedRoute, public restApi: RestApiService) {

    }

    //kaid=1001&confKey=f681c531e18c7612253e20069ef28c0e&art=Kerze

    ngOnInit(): void {
        this.route.queryParams.subscribe((params) => {
            //   console.log(params);
            this.kaid = params.kaid;
            this.confKey = params.confKey;
            this.art = params.art;
            console.log("kaid-> " + this.kaid);
            console.log("confKey-> " + this.confKey);
            console.log("art-> " + this.art);
            this.status_message= "Hallo";
            this.erg = this.confirmKondolenz();
            
        });
    }


    confirmKondolenz(): any{
        const headers = { "content-type": "application/json" };
        var confirmData = {
            kartenId: this.kaid,
            confKey: this.confKey,
            kondolenzArt: this.art
        };
        const body = JSON.stringify(confirmData);

       return this.restApi.confirmKondolenz(body).subscribe((data) => {
        this.status_message = data['status_message'];
       });

    }

    // gotoZurKarte():void{
    //     // this.router
    // }
}
